import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

// Format money values to avoid floating-point precision issues
// Rounds to 2 decimal places and formats with locale string
export function formatMoney(value, decimals = 2) {
  if (value === null || value === undefined || isNaN(value)) return '0';
  const rounded = Math.round(value * Math.pow(10, decimals)) / Math.pow(10, decimals);
  return rounded.toLocaleString();
}
